// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning[data-v-650ad451] {\n  margin-bottom: 25px;\n}\n.is-invalid[data-v-650ad451] {\n  padding-bottom: 25px;\n}\n@media (max-width: 767.9px) {\n.comment[data-v-650ad451] {\n    margin-bottom: 20px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
